module.exports = __webpack_public_path__ + "static/img/filter_icon.f7465d56.svg";